// import React, { useState } from 'react';
// import logo from "../reactnest.png";
// import { Link } from "react-router-dom";
// import { CheckCircle, XCircle, AlertCircle, Info, Github, Instagram } from 'lucide-react';

// const ContactPage = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     subject: '',
//     message: ''
//   });
//   const [errors, setErrors] = useState({
//     name: '',
//     email: '',
//     subject: '',
//     message: ''
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [notification, setNotification] = useState({
//     show: false,
//     type: '',
//     message: ''
//   });

//   // Email validation function
//   const validateEmail = (email) => {
//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     return emailRegex.test(email);
//   };

//   // Validation function
//   const validateForm = () => {
//     const newErrors = {
//       name: '',
//       email: '',
//       subject: '',
//       message: ''
//     };

//     // Name validation
//     if (!formData.name.trim()) {
//       newErrors.name = 'Name is required';
//     } else if (formData.name.trim().length < 2) {
//       newErrors.name = 'Name must be at least 2 characters long';
//     }

//     // Email validation
//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!validateEmail(formData.email)) {
//       newErrors.email = 'Please enter a valid email address';
//     }

//     // Subject validation
//     if (!formData.subject) {
//       newErrors.subject = 'Please select a subject';
//     }

//     // Message validation
//     if (!formData.message.trim()) {
//       newErrors.message = 'Message is required';
//     } else if (formData.message.trim().length < 10) {
//       newErrors.message = 'Message must be at least 10 characters long';
//     }

//     setErrors(newErrors);
    
//     // Return true if no errors
//     return !Object.values(newErrors).some(error => error !== '');
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));

//     // Clear error when user starts typing
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   const showNotification = (type, message) => {
//     setNotification({
//       show: true,
//       type,
//       message
//     });

//     // Auto hide after 5 seconds
//     setTimeout(() => {
//       setNotification({
//         show: false,
//         type: '',
//         message: ''
//       });
//     }, 5000);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     // Validate form before submitting
//     if (!validateForm()) {
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       const response = await fetch("/.netlify/functions/sendEmail", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       if (response.ok) {
//         showNotification('success', 'Message sent successfully! We\'ll get back to you soon.');
//         setFormData({ 
//           name: "", 
//           email: "", 
//           subject: "", 
//           message: "" 
//         });
//         setErrors({
//           name: '',
//           email: '',
//           subject: '',
//           message: ''
//         });
//       } else {
//         showNotification('error', 'Failed to send message. Please try again.');
//       }
//     } catch (err) {
//       console.error(err);
//       showNotification('error', 'Something went wrong. Please check your connection and try again.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Contact methods data
//    const contactMethods = [
//     {
//       icon: '📧',
//       title: 'Email Support',
//       description: 'Get help with technical issues',
//       contact: 'reactnestteam@gmail.com',
//       action: 'Send Email',
//       onClick: () => {
//         const email = 'reactnestteam@gmail.com';
//         const subject = 'Support Request';
        
//         const outlookUrl = `https://outlook.live.com/mail/0/deeplink/compose?to=${email}&subject=${encodeURIComponent(subject)}`;
//         const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}`;
//         const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
        
//         const outlookWindow = window.open(outlookUrl, '_blank');
        
//         setTimeout(() => {
//           if (!outlookWindow || outlookWindow.closed) {
//             const gmailWindow = window.open(gmailUrl, '_blank');
            
//             setTimeout(() => {
//               if (!gmailWindow || gmailWindow.closed) {
//                 window.location.href = mailtoUrl;
//               }
//             }, 1000);
//           }
//         }, 1000);
//       }
//     },
//     {
//       icon: '🐛',
//       title: 'Report Issues',
//       description: 'Found a bug? Let us know',
//       contact: 'GitHub Issues',
//       action: 'Report Bug',
//       onClick: () => {
//         const githubIssuesUrl = 'https://github.com/prem-soni/reactnest/issues/new';
//         window.open(githubIssuesUrl, '_blank');
//       }
//     }
//   ];

//   const socialLinksLucide = [
//     {
//       name: 'GitHub',
//       handle: '@reactnest',
//       icon: Github,
//       url: 'https://github.com/prem-soni/reactnest',
//       color: 'group-hover:text-gray-300'
//     },
//     {
//       name: 'Instagram', 
//       handle: '@reactnest.dev',
//       icon: Instagram,
//       url: 'https://www.instagram.com/reactnest_dev/',
//       color: 'group-hover:text-pink-400'
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-black text-white font-sans">
//       {/* Animated Background */}
//       <div className="fixed inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute -top-40 -left-40 w-80 h-80 bg-gradient-to-br from-purple-600/20 to-pink-500/20 rounded-full blur-3xl animate-pulse"></div>
//         <div className="absolute top-1/2 -right-40 w-96 h-96 bg-gradient-to-bl from-blue-600/20 to-purple-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
//         <div className="absolute -bottom-40 left-1/4 w-72 h-72 bg-gradient-to-tr from-pink-500/20 to-purple-600/20 rounded-full blur-3xl animate-pulse delay-2000"></div>
//       </div>

//       {/* Navigation */}
//       <nav className="relative z-50 bg-black/40 backdrop-blur-xl border-b border-white/10">
//         <div className="max-w-7xl mx-auto px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <Link to="/" className="flex items-center space-x-3">
//               <span className="text-2xl">
//                 <img src={logo} alt="React Nest Logo" className="w-14 h-14"/>
//               </span>
//               <span className="text-xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
//                 React Nest
//               </span>
//             </Link>
            
//             {/* Desktop Menu */}
//             <div className="hidden md:flex items-center space-x-8">
//               <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-300 hover:scale-105 transform">Home</Link>
//               <a href="#contact-form" className="text-gray-300 hover:text-white transition-colors duration-300 hover:scale-105 transform">Contact</a>
//             </div>

//             {/* Mobile Menu Button */}
//             <button 
//               className="md:hidden text-white"
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//             >
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
//               </svg>
//             </button>
//           </div>
//         </div>

//         {/* Mobile Menu */}
//         {isMenuOpen && (
//           <div className="md:hidden bg-black/90 backdrop-blur-xl border-t border-white/10">
//             <div className="px-6 py-4 space-y-4">
//               <Link to="/" className="block text-gray-300 hover:text-white transition-colors">Home</Link>
//               <a href="#contact-form" className="block text-gray-300 hover:text-white transition-colors">Contact</a>
//             </div>
//           </div>
//         )}
//       </nav>

//       {/* Hero Section */}
//       <section className="relative py-20 px-6 lg:px-8">
//         <div className="max-w-7xl mx-auto text-center space-y-8">
//           <div className="space-y-4">
//             <h1 className="text-5xl lg:text-7xl font-black leading-tight">
//               Get in
//               <span className="block bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
//                 Touch
//               </span>
//             </h1>
//             <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
//               Have questions, suggestions, or need help? We're here to assist you on your React development journey.
//             </p>
//           </div>

//           {/* Quick Stats */}
//           <div className="flex justify-center space-x-12 lg:space-x-20 my-12">
//             {[
//               { number: '<2h', label: 'Response Time' },
//               { number: '24/7', label: 'Community Support' },
//               { number: '99%', label: 'Issue Resolution' }
//             ].map((stat, index) => (
//               <div key={index} className="text-center">
//                 <div className="text-2xl lg:text-3xl font-black bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
//                   {stat.number}
//                 </div>
//                 <div className="text-gray-400 mt-2 text-sm">{stat.label}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Support Channels */}
//       <section id="support" className="relative py-20 px-6 lg:px-8">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center space-y-4 mb-16">
//             <h2 className="text-4xl lg:text-5xl font-bold">
//               Choose Your 
//               <span className="bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent"> Support Channel</span>
//             </h2>
//             <p className="text-xl text-gray-400 max-w-2xl mx-auto">
//               Multiple ways to reach us, choose what works best for you
//             </p>
//           </div>
          
//           <div className="flex justify-center">
//             <div className="grid md:grid-cols-2 gap-8 max-w-2xl">
//               {contactMethods.map((method, index) => (
//                 <div 
//                   key={index}
//                   className="group p-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl hover:bg-white/10 transition-all duration-500 hover:scale-105 hover:border-purple-500/50 cursor-pointer"
//                   onClick={method.onClick}
//                 >
//                   <div className="text-center space-y-4">
//                     <div className="text-5xl group-hover:scale-110 transition-transform duration-300">
//                       {method.icon}
//                     </div>
//                     <h3 className="text-xl font-bold text-white">{method.title}</h3>
//                     <p className="text-gray-400 leading-relaxed text-sm">{method.description}</p>
//                     <div className="space-y-2">
//                       <p className="text-purple-400 text-sm font-medium">{method.contact}</p>
//                       <button className="w-full py-2 px-4 bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/30 rounded-xl text-purple-300 hover:bg-gradient-to-r hover:from-purple-500/30 hover:to-pink-500/30 transition-all duration-300 text-sm">
//                         {method.action}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//           <section id="contact-form" className="relative py-20 px-6 lg:px-8">
//         <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 via-purple-600/5 to-pink-500/5"></div>
//         <div className="relative max-w-5xl mx-auto">
//           <div className="text-center space-y-4 mb-16">
//             <h2 className="text-4xl lg:text-5xl font-bold">
//               Send Us a 
//               <span className="bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">Message</span>
//             </h2>
//             <p className="text-xl text-gray-400 max-w-2xl mx-auto">
//               Fill out the form below and we'll get back to you as soon as possible
//             </p>
//           </div>

//           {/* Notification */}
//           {notification.show && (
//             <div className={`fixed top-4 right-4 z-50 max-w-md p-4 rounded-xl border backdrop-blur-xl transition-all duration-500 transform ${
//               notification.type === 'success' 
//                 ? 'bg-green-500/10 border-green-500/30 text-green-300'
//                 : 'bg-red-500/10 border-red-500/30 text-red-300'
//             } animate-in slide-in-from-right`}>
//               <div className="flex items-center justify-between">
//                 <div className="flex items-center space-x-2">
//                   {notification.type === 'success' ? (
//                     <CheckCircle className="w-5 h-5" />
//                   ) : (
//                     <XCircle className="w-5 h-5" />
//                   )}
//                   <p className="font-medium">{notification.message}</p>
//                 </div>
//                 <button 
//                   onClick={() => setNotification({show: false, type: '', message: ''})}
//                   className="ml-4 text-white/60 hover:text-white transition-colors"
//                 >
//                   ×
//                 </button>
//               </div>
//             </div>
//           )}

//           <div className="grid lg:grid-cols-2 gap-12">
//             {/* Contact Form */}
//             <div className="relative">
//               <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-3xl blur-xl"></div>
//               <div className="relative bg-white/5 backdrop-blur-xl border border-white/20 rounded-3xl p-8 space-y-6">
//                 <form onSubmit={handleSubmit}>
//                   <div className="grid md:grid-cols-2 gap-6 mb-6">
//                     <div>
//                       <label className="block text-white font-medium mb-3">Name</label>
//                       <input
//                         type="text"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleInputChange}                      
//                         className={`w-full h-12 bg-white/10 border rounded-xl px-4 py-3 text-white focus:outline-none transition-all duration-300 ${
//                           errors.name 
//                             ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/20' 
//                             : 'border-white/20 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20'
//                         }`}
//                       />
//                       <p className="mt-2 text-sm text-gray-400">
//                         {errors.name ? (
//                           <span className="text-red-400">{errors.name}</span>
//                         ) : (
//                           "Enter your full name as you'd like to be addressed"
//                         )}
//                       </p>
//                     </div>
//                     <div>
//                       <label className="block text-white font-medium mb-3">Email</label>
//                       <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleInputChange}                        
//                         className={`w-full h-12 bg-white/10 border rounded-xl px-4 py-3 text-white focus:outline-none transition-all duration-300 ${
//                           errors.email 
//                             ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/20' 
//                             : 'border-white/20 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20'
//                         }`}
//                       />
//                       <p className="mt-2 text-sm text-gray-400">
//                         {errors.email ? (
//                           <span className="text-red-400">{errors.email}</span>
//                         ) : (
//                           "We'll use this to send you a response"
//                         )}
//                       </p>
//                     </div>
//                   </div>
                  
//                   <div className="mb-6">
//                     <label className="block text-white font-medium mb-3">Subject</label>
//                     <div className="relative">
//                       <select
//                         name="subject"
//                         value={formData.subject}
//                         onChange={handleInputChange}                        
//                         className={`w-full h-12 bg-white/10 border rounded-xl px-4 py-3 text-white focus:outline-none transition-all duration-300 appearance-none cursor-pointer ${
//                           errors.subject 
//                             ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/20' 
//                             : 'border-white/20 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20'
//                         }`}
//                       >
//                         <option value="" className="bg-gray-800 text-gray-400">Select a subject</option>
//                         <option value="general" className="bg-gray-800 text-white">General Inquiry</option>
//                         <option value="support" className="bg-gray-800 text-white">Technical Support</option>
//                         <option value="bug" className="bg-gray-800 text-white">Bug Report</option>
//                         <option value="feature" className="bg-gray-800 text-white">Feature Request</option>
//                         <option value="partnership" className="bg-gray-800 text-white">Partnership</option>
//                       </select>
//                       {/* Custom dropdown arrow */}
//                       <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
//                         <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
//                         </svg>
//                       </div>
//                     </div>
//                     <p className="mt-2 text-sm text-gray-400">
//                       {errors.subject ? (
//                         <span className="text-red-400">{errors.subject}</span>
//                       ) : (
//                         "Choose the category that best describes your inquiry"
//                       )}
//                     </p>
//                   </div>
                  
//                   <div className="mb-6">
//                     <label className="block text-white font-medium mb-3">Message</label>
//                     <textarea
//                       name="message"
//                       value={formData.message}
//                       onChange={handleInputChange}
//                       rows="6"                      
//                       className={`w-full bg-white/10 border rounded-xl px-4 py-3 text-white focus:outline-none transition-all duration-300 resize-none ${
//                         errors.message 
//                           ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/20' 
//                           : 'border-white/20 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20'
//                       }`}
//                     ></textarea>
//                     <p className="mt-2 text-sm text-gray-400">
//                       {errors.message ? (
//                         <span className="text-red-400">{errors.message}</span>
//                       ) : (
//                         "Provide details about your request. The more specific, the better we can help"
//                       )}
//                     </p>
//                   </div>

//                   <button 
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="w-full py-4 bg-gradient-to-r from-blue-500 via-purple-600 to-pink-500 rounded-xl font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/25 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
//                   >
//                     {isSubmitting ? (
//                       <span className="flex items-center justify-center space-x-2">
//                         <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                         <span>Sending...</span>
//                       </span>
//                     ) : (
//                       'Send Message'
//                     )}
//                   </button>
//                 </form>
//               </div>
//             </div>

//             {/* Social Links */}
//             <div className="space-y-8">
//               <div className="bg-white/5 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
//                 <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
//                   Follow Us
//                 </h3>
//                 <div className="grid grid-cols-2 gap-4">
//                   {socialLinksLucide.map((social, index) => {
//                     const IconComponent = social.icon;
//                     return (
//                       <a
//                         key={index}
//                         href={social.url}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="flex items-center space-x-3 p-4 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 hover:border-purple-500/50 transition-all duration-300 group cursor-pointer"
//                       >
//                         <IconComponent className={`w-6 h-6 text-white group-hover:scale-110 transition-all duration-300 ${social.color}`} />
//                         <div className="text-left">
//                           <p className="text-white font-medium text-sm">{social.name}</p>
//                           <p className="text-gray-400 text-xs">{social.handle}</p>
//                         </div>
//                       </a>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="relative border-t border-white/10 py-12 px-6 lg:px-8">
//         <div className="max-w-7xl mx-auto">
//           <div className="flex flex-col justify-center items-center space-y-6">
//             <div className="flex items-center space-x-3">
//               <span className="text-2xl">
//                 <img src={logo} alt="React Nest Logo" className="w-14 h-14"/>
//               </span>
//               <span className="text-xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
//                 React Nest
//               </span>
//             </div>
//           </div>
        
//           <div className="mt-8 pt-8 border-t border-white/10 text-center text-gray-400">
//             <p>&copy; 2025 React Nest. Made with ❤️ for React developers.</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default ContactPage;
import React, { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import logo from "../reactnest.png";
import { Link } from "react-router-dom";
import { CheckCircle, XCircle, AlertCircle, Info, Github, Instagram } from 'lucide-react';

gsap.registerPlugin(ScrollTrigger);

const ContactPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    type: '',
    message: ''
  });

  // Animation refs
  const heroTitleRef = useRef(null);
  const heroSubtitleRef = useRef(null);
  const heroDescriptionRef = useRef(null);
  const statsRef = useRef([]);
  const supportSectionRef = useRef(null);
  const contactMethodsRef = useRef([]);
  const formSectionRef = useRef(null);
  const formContainerRef = useRef(null);
  const socialContainerRef = useRef(null);
  const floatingElementsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Hero Section Animations
      const heroTl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      
      heroTl
        .from(heroTitleRef.current, {
          y: -100,
          opacity: 0,
          duration: 1,
          delay: 0.2,
          ease: 'power3.out'
        })
        .from(heroSubtitleRef.current, {
          scale: 0.5,
          opacity: 0,
          duration: 1,
          ease: 'back.out(1.7)'
        }, '-=0.5')
        .from(heroDescriptionRef.current, {
          y: 50,
          opacity: 0,
          duration: 0.8
        }, '-=0.4');

      // Stats animation
      statsRef.current.forEach((stat, index) => {
        if (stat) {
          gsap.from(stat, {
            scale: 0,
            opacity: 0,
            duration: 0.6,
            delay: 0.8 + index * 0.15,
            ease: 'elastic.out(1, 0.5)'
          });
        }
      });

      // Continuous floating animation for hero subtitle
      gsap.to(heroSubtitleRef.current, {
        y: -10,
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });

      // Floating elements animation
      floatingElementsRef.current.forEach((el, index) => {
        if (el) {
          gsap.to(el, {
            y: -30,
            x: index % 2 === 0 ? 20 : -20,
            duration: 2 + index * 0.5,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut',
            delay: index * 0.2
          });

          gsap.to(el, {
            rotation: index % 2 === 0 ? 360 : -360,
            duration: 10 + index * 2,
            repeat: -1,
            ease: 'linear'
          });
        }
      });

      // Support Section Animation
      gsap.from(supportSectionRef.current.querySelector('h2'), {
        scrollTrigger: {
          trigger: supportSectionRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        scale: 0.8,
        opacity: 0,
        duration: 0.8,
        ease: 'back.out(1.4)'
      });

      gsap.from(supportSectionRef.current.querySelector('p'), {
        scrollTrigger: {
          trigger: supportSectionRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        y: 30,
        opacity: 0,
        duration: 0.6,
        delay: 0.2
      });

      // Contact Methods Cards Stagger Animation
      contactMethodsRef.current.forEach((card, index) => {
        if (card) {
          gsap.from(card, {
            scrollTrigger: {
              trigger: card,
              start: 'top 85%',
              toggleActions: 'play none none reverse'
            },
            y: 80,
            opacity: 0,
            scale: 0.8,
            rotation: -10,
            duration: 0.7,
            delay: index * 0.2,
            ease: 'back.out(1.2)'
          });
        }
      });

      // Form Section Animation
      gsap.from(formSectionRef.current.querySelector('h2'), {
        scrollTrigger: {
          trigger: formSectionRef.current,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        },
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out'
      });

      gsap.from(formSectionRef.current.querySelector('p'), {
        scrollTrigger: {
          trigger: formSectionRef.current,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        },
        y: 30,
        opacity: 0,
        duration: 0.6,
        delay: 0.2
      });

      // Form Container Animation
      gsap.from(formContainerRef.current, {
        scrollTrigger: {
          trigger: formContainerRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        },
        x: -100,
        opacity: 0,
        duration: 1,
        ease: 'power2.out'
      });

      // Make sure form inputs and submit button are visible immediately.
      const formInputs = formContainerRef.current.querySelectorAll('input, select, textarea, button[type="submit"]');
      gsap.set(formInputs, { opacity: 1, y: 0, scale: 1, clearProps: 'all' });

      // Social Container Animation with enhanced visibility
  
       if (socialContainerRef.current) {
          const container = socialContainerRef.current;
          const socialLinks = container.querySelectorAll('a');
          const socialTitle = container.querySelector('h3');

          // --- 1. Clear previous animations and define the ScrollTrigger ---
          // It's good practice to kill previous tweens before creating new ones in React/useEffect
          gsap.killTweensOf([container, socialTitle, socialLinks]);

          const triggerConfig = {
            trigger: container,
            start: 'top 85%',
            toggleActions: 'play none none reverse', // Play on scroll in, reverse on scroll out
            once: false,
          };

          // --- 2. Initial State Setup & Container Entrance ---

          // 2a. Set initial states for elements before the main animation
          gsap.set(socialLinks, { opacity: 0, scale: 0.8, y: 20, rotation: 0 });
          if (socialTitle) {
            gsap.set(socialTitle, { opacity: 0, x: -50, scale: 1 });
          }

          // 2b. Animate the main container (sets the scene)
          gsap.from(container, {
            scrollTrigger: triggerConfig,
            y: 80, // Larger movement for impact
            opacity: 0,
            duration: 1.2,
            ease: 'power3.out', // Smoother ease
          });

          // --- 3. Content Entrance Timeline (Title & Links) ---
          const entranceTimeline = gsap.timeline({
            scrollTrigger: triggerConfig,
            // Use this onComplete to start the permanent floating loop
            onComplete: () => {
              // Start the continuous floating animation only once
              socialLinks.forEach((link, index) => {
                gsap.to(link, {
                  y: -5, // Subtle float up and down
                  rotation: index % 2 === 0 ? 0.5 : -0.5, // Gentle rocking motion
                  duration: 3 + Math.random() * 2, // Vary duration for a more organic feel
                  repeat: -1,
                  yoyo: true,
                  ease: 'sine.inOut',
                  delay: index * 0.15, // Stagger the start of the float
                });
              });
            },
            onReverseComplete: () => {
              // Kill the continuous floating animation when scrolling reverse
              socialLinks.forEach(link => gsap.killTweensOf(link));
              // Reset properties to initial state for the next run
              gsap.set(socialLinks, { clearProps: 'all' });
            }
          });

          // 3a. Animate the Title
          if (socialTitle) {
            entranceTimeline.to(socialTitle, {
              x: 0,
              opacity: 1,
              duration: 0.8,
              ease: 'power2.out',
            }, 0.3); // Start 0.3s into the container's animation

            // 3b. Social Links Stagger
            entranceTimeline.to(socialLinks, {
              opacity: 1,
              scale: 1,
              y: 0,
              rotation: 0,
              duration: 0.6,
              stagger: 0.1, // Quicker, tighter stagger
              ease: 'back.out(2.5)', // More satisfying bounce
            }, '<0.2'); // Start the links 0.2s *after* the title starts
          }
        }


    });

    ScrollTrigger.refresh();
    return () => ctx.revert();
  }, []);

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  // Validation function
  const validateForm = () => {
    const newErrors = {
      name: '',
      email: '',
      subject: '',
      message: ''
    };

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Name must be at least 2 characters long';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.subject) {
      newErrors.subject = 'Please select a subject';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters long';
    }

    setErrors(newErrors);
    return !Object.values(newErrors).some(error => error !== '');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const showNotification = (type, message) => {
    setNotification({
      show: true,
      type,
      message
    });

    setTimeout(() => {
      setNotification({
        show: false,
        type: '',
        message: ''
      });
    }, 5000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch("/.netlify/functions/sendEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        showNotification('success', 'Message sent successfully! We\'ll get back to you soon.');
        setFormData({ 
          name: "", 
          email: "", 
          subject: "", 
          message: "" 
        });
        setErrors({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        showNotification('error', 'Failed to send message. Please try again.');
      }
    } catch (err) {
      console.error(err);
      showNotification('error', 'Something went wrong. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactMethods = [
    {
      icon: '📧',
      title: 'Email Support',
      description: 'Get help with technical issues',
      contact: 'reactnestteam@gmail.com',
      action: 'Send Email',
      onClick: () => {
        const email = 'reactnestteam@gmail.com';
        const subject = 'Support Request';
        
        const outlookUrl = `https://outlook.live.com/mail/0/deeplink/compose?to=${email}&subject=${encodeURIComponent(subject)}`;
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}`;
        const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
        
        const outlookWindow = window.open(outlookUrl, '_blank');
        
        setTimeout(() => {
          if (!outlookWindow || outlookWindow.closed) {
            const gmailWindow = window.open(gmailUrl, '_blank');
            
            setTimeout(() => {
              if (!gmailWindow || gmailWindow.closed) {
                window.location.href = mailtoUrl;
              }
            }, 1000);
          }
        }, 1000);
      }
    },
    {
      icon: '🐛',
      title: 'Report Issues',
      description: 'Found a bug? Let us know',
      contact: 'GitHub Issues',
      action: 'Report Bug',
      onClick: () => {
        const githubIssuesUrl = 'https://github.com/prem-soni/reactnest/issues/new';
        window.open(githubIssuesUrl, '_blank');
      }
    }
  ];

  const socialLinksLucide = [
    {
      name: 'GitHub',
      handle: '@reactnest',
      icon: Github,
      url: 'https://github.com/prem-soni/reactnest',
      color: 'group-hover:text-gray-300'
    },
    {
      name: 'Instagram', 
      handle: '@reactnest.dev',
      icon: Instagram,
      url: 'https://www.instagram.com/reactnest_dev/',
      color: 'group-hover:text-pink-400'
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -left-40 w-80 h-80 bg-gradient-to-br from-purple-600/20 to-pink-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute top-1/2 -right-40 w-96 h-96 bg-gradient-to-bl from-blue-600/20 to-purple-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute -bottom-40 left-1/4 w-72 h-72 bg-gradient-to-tr from-pink-500/20 to-purple-600/20 rounded-full blur-3xl animate-pulse delay-2000"></div>
      </div>

      {/* Floating animated shapes */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div ref={el => floatingElementsRef.current[0] = el} className="absolute top-20 left-10 w-20 h-20 border-2 border-purple-500/30 rounded-lg"></div>
        <div ref={el => floatingElementsRef.current[1] = el} className="absolute top-40 right-20 w-16 h-16 border-2 border-blue-500/30 rounded-full"></div>
        <div ref={el => floatingElementsRef.current[2] = el} className="absolute bottom-40 left-20 w-24 h-24 border-2 border-pink-500/30 rounded-lg"></div>
        <div ref={el => floatingElementsRef.current[3] = el} className="absolute bottom-20 right-40 w-12 h-12 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-full blur-xl"></div>
      </div>

      {/* Navigation */}
      <nav className="relative z-50 bg-black/40 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-3">
              <span className="text-2xl">
                <img src={logo} alt="React Nest Logo" className="w-14 h-14"/>
              </span>
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
                React Nest
              </span>
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-300 hover:scale-105 transform">Home</Link>
              <a href="#contact-form" className="text-gray-300 hover:text-white transition-colors duration-300 hover:scale-105 transform">Contact</a>
            </div>

            <button 
              className="md:hidden text-white"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
              </svg>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-black/90 backdrop-blur-xl border-t border-white/10">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-gray-300 hover:text-white transition-colors">Home</Link>
              <a href="#contact-form" className="block text-gray-300 hover:text-white transition-colors">Contact</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center space-y-8">
          <div className="space-y-4">
            <h1 ref={heroTitleRef} className="text-5xl lg:text-7xl font-black leading-tight">
              Get in
            </h1>
            <span 
              ref={heroSubtitleRef}
              className="block text-5xl lg:text-7xl font-black bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent"
            >
              Touch
            </span>
            <p ref={heroDescriptionRef} className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
              Have questions, suggestions, or need help? We're here to assist you on your React development journey.
            </p>
          </div>

          {/* Quick Stats */}
          <div className="flex justify-center space-x-12 lg:space-x-20 my-12">
            {[
              { number: '<2h', label: 'Response Time' },
              { number: '24/7', label: 'Community Support' },
              { number: '99%', label: 'Issue Resolution' }
            ].map((stat, index) => (
              <div key={index} ref={el => statsRef.current[index] = el} className="text-center">
                <div className="text-2xl lg:text-3xl font-black bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
                  {stat.number}
                </div>
                <div className="text-gray-400 mt-2 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Support Channels */}
      <section ref={supportSectionRef} id="support" className="relative py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center space-y-4 mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold">
              Choose Your 
              <span className="bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent"> Support Channel</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Multiple ways to reach us, choose what works best for you
            </p>
          </div>
          
          <div className="flex justify-center">
            <div className="grid md:grid-cols-2 gap-8 max-w-2xl">
              {contactMethods.map((method, index) => (
                <div 
                  key={index}
                  ref={el => contactMethodsRef.current[index] = el}
                  className="group p-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl hover:bg-white/10 transition-all duration-500 hover:scale-105 hover:border-purple-500/50 cursor-pointer"
                  onClick={method.onClick}
                >
                  <div className="text-center space-y-4">
                    <div className="text-5xl group-hover:scale-110 transition-transform duration-300">
                      {method.icon}
                    </div>
                    <h3 className="text-xl font-bold text-white">{method.title}</h3>
                    <p className="text-gray-400 leading-relaxed text-sm">{method.description}</p>
                    <div className="space-y-2">
                      <p className="text-purple-400 text-sm font-medium">{method.contact}</p>
                      <button className="w-full py-2 px-4 bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/30 rounded-xl text-purple-300 hover:bg-gradient-to-r hover:from-purple-500/30 hover:to-pink-500/30 transition-all duration-300 text-sm">
                        {method.action}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section ref={formSectionRef} id="contact-form" className="relative py-20 px-6 lg:px-8">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 via-purple-600/5 to-pink-500/5"></div>
        <div className="relative max-w-5xl mx-auto">
          <div className="text-center space-y-4 mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold">
              Send Us a 
              <span className="bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">Message</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Fill out the form below and we'll get back to you as soon as possible
            </p>
          </div>

          {/* Notification */}
          {notification.show && (
            <div className={`fixed top-4 right-4 z-50 max-w-md p-4 rounded-xl border backdrop-blur-xl transition-all duration-500 transform ${
              notification.type === 'success' 
                ? 'bg-green-500/10 border-green-500/30 text-green-300'
                : 'bg-red-500/10 border-red-500/30 text-red-300'
            } animate-in slide-in-from-right`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  {notification.type === 'success' ? (
                    <CheckCircle className="w-5 h-5" />
                  ) : (
                    <XCircle className="w-5 h-5" />
                  )}
                  <p className="font-medium">{notification.message}</p>
                </div>
                <button 
                  onClick={() => setNotification({show: false, type: '', message: ''})}
                  className="ml-4 text-white/60 hover:text-white transition-colors"
                >
                  ×
                </button>
              </div>
            </div>
          )}

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-3xl blur-xl"></div>
              <div ref={formContainerRef} className="relative bg-white/5 backdrop-blur-xl border border-white/20 rounded-3xl p-8 space-y-6">
                <form onSubmit={handleSubmit}>
                  <div className="grid md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-white font-medium mb-3">Name</label>
                      <input type="text" name="name"
                        value={formData.name}
                        onChange={handleInputChange}                      
                        className={`w-full h-12 bg-white/10 border border-white/30 rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:outline-none transition-all duration-300 ${
                            errors.name 
                              ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/20' 
                              : 'focus:border-purple-500 focus:ring-2 focus:ring-purple-500/30'
                          }`}
                      />
                      <p className="mt-2 text-sm text-gray-400">
                        {errors.name ? (
                          <span className="text-red-400">{errors.name}</span>
                        ) : (
                          "Enter your full name as you'd like to be addressed"
                        )}
                      </p>
                    </div>
                    <div>
                      <label className="block text-white font-medium mb-3">Email</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}                        
                        className={`w-full h-12 bg-white/10 border border-white/30 rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:outline-none transition-all duration-300 ${
                          errors.email 
                            ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/20' 
                            : 'focus:border-purple-500 focus:ring-2 focus:ring-purple-500/30'
                        }`}
                      />
                      <p className="mt-2 text-sm text-gray-400">
                        {errors.email ? (
                          <span className="text-red-400">{errors.email}</span>
                        ) : (
                          "We'll use this to send you a response"
                        )}
                      </p>
                    </div>
                  </div>
                  
                  <div className="mb-6">
                    <label className="block text-white font-medium mb-3">Subject</label>
                    <div className="relative">
                      <select
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}                        
                        className={`w-full h-12 bg-white/10 border border-white/30 rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:outline-none transition-all duration-300 appearance-none cursor-pointer ${
                          errors.subject 
                            ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/20' 
                            : 'focus:border-purple-500 focus:ring-2 focus:ring-purple-500/30'
                        }`}
                      >
                        <option value="" className="bg-gray-800 text-gray-400">Select a subject</option>
                        <option value="general" className="bg-gray-800 text-white">General Inquiry</option>
                        <option value="support" className="bg-gray-800 text-white">Technical Support</option>
                        <option value="bug" className="bg-gray-800 text-white">Bug Report</option>
                        <option value="feature" className="bg-gray-800 text-white">Feature Request</option>
                        <option value="partnership" className="bg-gray-800 text-white">Partnership</option>
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                      </div>
                    </div>
                    {errors.subject && (
                      <p className="mt-2 text-sm text-red-400">{errors.subject}</p>
                    )}
                  </div>
                  
                  <div className="mb-6">
                    <label className="block text-white font-medium mb-3">Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows="6"
                      placeholder="Provide details about your request. The more specific, the better we can help"
                      className={`w-full bg-white/10 border border-white/30 rounded-xl px-4 py-3 text-white placeholder-gray-400 focus:outline-none transition-all duration-300 resize-none ${
                        errors.message 
                          ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/20' 
                          : 'focus:border-purple-500 focus:ring-2 focus:ring-purple-500/30'
                      }`}
                    ></textarea>
                    {errors.message && (
                      <p className="mt-2 text-sm text-red-400">{errors.message}</p>
                    )}
                  </div>

                  <button 
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-4 bg-gradient-to-r from-blue-500 via-purple-600 to-pink-500 rounded-xl font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/25 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                  >
                    {isSubmitting ? (
                      <span className="flex items-center justify-center space-x-2">
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        <span>Sending...</span>
                      </span>
                    ) : (
                      'Send Message'
                    )}
                  </button>
                </form>
              </div>
            </div>

            {/* Follow Us Section */}
            <div ref={socialContainerRef} className="space-y-8">
              <div className="relative bg-white/5 backdrop-blur-xl border border-white/20 rounded-3xl p-8 overflow-hidden">
                {/* Animated gradient background */}
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 via-transparent to-pink-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <h3 className="relative text-2xl font-bold mb-6 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
                  Follow Us
                </h3>
                <div className="relative grid grid-cols-2 gap-4">
                  {socialLinksLucide.map((social, index) => {
                    const IconComponent = social.icon;
                    return (
                      <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="relative flex items-center space-x-3 p-4 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 hover:border-purple-500/50 transition-all duration-300 group cursor-pointer overflow-hidden"
                      >
                        {/* Hover glow effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/0 via-purple-500/20 to-pink-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        
                        <IconComponent className={`relative w-6 h-6 text-white group-hover:scale-110 transition-all duration-300 ${social.color}`} />
                        <div className="relative text-left">
                          <p className="text-white font-medium text-sm group-hover:text-purple-300 transition-colors duration-300">{social.name}</p>
                          <p className="text-gray-400 text-xs group-hover:text-gray-300 transition-colors duration-300">{social.handle}</p>
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative border-t border-white/10 py-12 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col justify-center items-center space-y-6">
            <div className="flex items-center space-x-3">
              <span className="text-2xl">
                <img src={logo} alt="React Nest Logo" className="w-14 h-14"/>
              </span>
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
                React Nest
              </span>
            </div>
          </div>
        
          <div className="mt-8 pt-8 border-t border-white/10 text-center text-gray-400">
            <p>&copy; 2025 React Nest. Made with ❤️ for React developers.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;